import a from"../../../helpers/AxiosURLSearchParams.js";var r="undefined"!=typeof URLSearchParams?URLSearchParams:a;export{r as default};
